import { useState } from 'react';
import '../../App.css';
import './QuemSomosPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import CarrosselFotos from '../../components/CarrosselFotos/CarrosselFotos';

import logo from '../../assets/img/logotipo.png';

export default function QuemSomosPage(){

  return (
    <div className="QuemSomos-container">
        <Header/>
        
        <article>
          <div className='QuemSomos'>
            <div className="QuemSomos-logo">
                <img src={logo} alt="Logotipo"  />
            </div>
            <div className="QuemSomos-texto">
            Somos especialistas dedicados a transformar cuidados de beleza em momentos únicos. 
            Nossa equipe é composta por profissionais experientes e apaixonados, sempre em busca de proporcionar 
            o melhor em qualidade e atendimento.
            <br/>
            Cada cliente é recebido com atenção e respeito, em um espaço criado para garantir conforto e bem-estar.
            Acreditamos que o cuidado com a beleza vai além do serviço prestado: é sobre criar conexões e proporcionar 
            experiências marcantes.
            <br/>
            Nosso ambiente combina modernidade, acolhimento e um toque especial de elegância. Cada detalhe foi pensado para 
            que você se sinta à vontade e tenha a certeza de que está em boas mãos.
            <br/>
            Estamos sempre atualizados com as tendências e técnicas mais avançadas, garantindo resultados que superam 
            expectativas. Seja qual for a sua necessidade, estamos prontos para atender com dedicação e profissionalismo.
            <br/>
            Venha nos conhecer e descubra um espaço onde o cuidado e a beleza se encontram.
            </div>
            
            <div className="QuemSomos-carrossel">
                <CarrosselFotos />
            </div>
          </div>
        </article>

        <Footer />
    </div>
  );  
}